import React from "react";
import classnames from "classnames";
import { Grid } from "luna-react/components/grid";
import { ArrowRight, ArrowLeft } from "luna-react/icons/";

import "./scss/Tabs.scss";

export const ResponsiveHeader = ({
  active = 0,
  setActive = () => {},
  items = [],
}) => {
  return (
    <div className="tab_header">
      <div className="tab_button tab_button--left">
        <ArrowLeft onClick={() => setActive(active - 1)} />
      </div>
      <div className="tab_slider">
        <div
          style={{
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${active * 200}px)`,
          }}
        >
          {items.map((item, index) => (
            <Tab
              key={index}
              onSelect={() => setActive(index)}
              isActive={active === index}
              content={item.title}
            />
          ))}
        </div>
      </div>
      <div className="tab_button tab_button--right">
        {" "}
        <ArrowRight onClick={() => setActive(active + 1)} />
      </div>
    </div>
  );
};

export const PlainHeader = ({ active = 0, setActive, items = [] }) => {
  return (
    <div className="tab_header">
      {items.map((item, index) => (
        <Tab
          key={index}
          onSelect={() => setActive(index)}
          isActive={active === index}
          content={item.title}
        />
      ))}
    </div>
  );
};

export const Tab = ({ content, onSelect, isActive = false }) => {
  const classNames = classnames("header_item", {
    "is-active": isActive,
  });
  return (
    <a
      onClick={onSelect}
      className={classNames}
      role="tab"
      aria-selected={isActive}
    >
      {content}
    </a>
  );
};

export class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      responsive: false,
    };
    this.delta = 200;
    this.setActive = this.setActive.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    const { items = [] } = props;
    this.defaultBreakpoint = 250 * items.length; //TODO: better implementation for this.
    const { showArrowsAt = this.defaultBreakpoint } = props;
    this.viewportChangeHandler = window.matchMedia(
      `(max-width: ${Math.max(showArrowsAt, this.defaultBreakpoint)}px)`
    );
  }
  setActive(index) {
    const { items } = this.props;
    const tabIndex = Math.max(0, Math.min(index, items.length - 1));

    this.setState({
      active: tabIndex,
    });
  }
  handleViewportChange(event) {
    let newState = {
      responsive: false,
    };
    if (event.matches) {
      newState = {
        responsive: true,
      };
    } else {
    }
    this.setState(newState);
  }
  componentDidMount() {
    this.handleViewportChange(this.viewportChangeHandler);
    this.viewportChangeHandler.addListener(this.handleViewportChange);
  }
  componentWillUnmount() {
    this.viewportChangeHandler.removeListener(this.handleViewportChange);
  }
  render() {
    const { items = [] } = this.props;
    const { active = 0, responsive } = this.state;
    const selectedContent = items[active] || {};
    const { title = "", content, image = null } = selectedContent;
    return (
      <div className="tab__wrapper">
        {responsive && (
          <ResponsiveHeader
            setActive={this.setActive}
            active={active}
            items={items}
          />
        )}
        {!responsive && (
          <PlainHeader
            setActive={this.setActive}
            active={active}
            items={items}
          />
        )}
        <Grid.Wrapper className="tab_content">
          {image && (
            <Grid.Item className="tab_image__wrapper" size={{ md: "1/2" }}>
              <img alt={title} className="tab_image" src={image} />
            </Grid.Item>
          )}
          <Grid.Item className="tab_content" size={image ? { md: "1/2" } : "1"}>
            {content}
          </Grid.Item>
        </Grid.Wrapper>
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/common/Tabs.js